var map = {
	"./冰雹_橙色预警.png": 56431,
	"./冰雹_红色预警.png": 75345,
	"./台风_橙色预警.png": 60391,
	"./台风_红色预警.png": 32616,
	"./台风_蓝色预警.png": 13693,
	"./台风_黄色预警.png": 16306,
	"./大雾_橙色预警.png": 63270,
	"./大雾_红色预警.png": 33367,
	"./大雾_黄色预警.png": 66535,
	"./大风_橙色预警.png": 79718,
	"./大风_红色预警.png": 63222,
	"./大风_蓝色预警.png": 42808,
	"./大风_黄色预警.png": 18870,
	"./寒潮_橙色预警.png": 90226,
	"./寒潮_红色预警.png": 48230,
	"./寒潮_蓝色预警.png": 5081,
	"./寒潮_黄色预警.png": 14480,
	"./干旱_橙色预警.png": 27277,
	"./干旱_红色预警.png": 30995,
	"./暴雨_橙色预警.png": 75853,
	"./暴雨_红色预警.png": 20751,
	"./暴雨_蓝色预警.png": 69496,
	"./暴雨_黄色预警.png": 42692,
	"./暴雪_橙色预警.png": 49646,
	"./暴雪_红色预警.png": 96032,
	"./暴雪_蓝色预警.png": 98291,
	"./暴雪_黄色预警.png": 23644,
	"./沙尘暴_橙色预警.png": 83249,
	"./沙尘暴_红色预警.png": 23625,
	"./沙尘暴_黄色预警.png": 32798,
	"./结冰_橙色预警.png": 9031,
	"./结冰_红色预警.png": 69611,
	"./结冰_黄色预警.png": 7195,
	"./重污染_橙色预警.png": 90381,
	"./重污染_红色预警.png": 80613,
	"./重污染_蓝色预警.png": 19087,
	"./重污染_黄色预警.png": 868,
	"./雷电_红色预警.png": 20394,
	"./雷电_黄色预警.png": 12546,
	"./霜冻_橙色预警.png": 95856,
	"./霜冻_蓝色预警.png": 58638,
	"./霜冻_黄色预警.png": 41595,
	"./霾_橙色预警.png": 40349,
	"./霾_黄色预警.png": 80527,
	"./高温_橙色预警.png": 29389,
	"./高温_红色预警.png": 72020,
	"./高温_黄色预警.png": 74394
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 78976;